import actionCreatorFactory from 'typescript-fsa';

import { FormName } from '@topconagriculture/feed-types';

import { ShareEditInvitation, ShareInvitation, SharingMessage } from '../../../core/api/sharing/sharing.types';
import reduxConfig from '../../config';

const actionCreator = actionCreatorFactory(reduxConfig.appName + '/sharing');

export const getShares = actionCreator.async<{}, SharingMessage[]>('GET_SHARES');
export const deleteSharePartner = actionCreator.async<{ id: string; formName: FormName }, {}>('DELETE_SHARE_PARTNER');
export const leaveInvitation = actionCreator.async<{ id: string; formName: FormName }, {}>('LEAVE_INVITATION');
export const sendShareInvite = actionCreator.async<{ data: ShareInvitation; formName: FormName }, any>(
  'SEND_SHARE_INVITE',
);
export const editInvite = actionCreator.async<ShareEditInvitation | string, any>('EDIT_INVITE');
export const acceptInvitation = actionCreator.async<{ id: string; formName: FormName }, {}>('ACCEPT_INVITATION');
export const checkShares = actionCreator.async<{}, {}>('CHECK_SHARES');
